import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  filter: {
    background: 'white',
    border: '1px solid rgb(224 224 224)',
    padding: '0 .5rem',
    borderBottom: 'none',
  },
  filter_header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: '1rem',
    marginTop: '0.5rem',
  },
  cardLayout: {},
}));

export default useStyles;
